"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = get;
exports.set = set;
exports.reset = reset;
exports.default = void 0;
var itemPurchased = false;

function get() {
  return itemPurchased;
}

function set() {
  itemPurchased = true;
}

function reset() {
  itemPurchased = false;
}

var _default = set;
exports.default = _default;